import React, { useEffect } from 'react';
import {
  Box,
  FlexControlledForm,
  useDebounceState,
} from '@common-fe/common-fe';

import { InvestmentProfilePayload,useStore } from '../stores/useInvestmentProfile.store';

import { usePurposeTypeFields } from './hooks';

interface Props {
  onDirty?: (isDirty: boolean) => void;
}

const PurposeType: React.FC<Props> = ({ onDirty }) => {
  const fields = usePurposeTypeFields();
  const handleSetState = useStore((state) => state.setState);
  const showErrors = useStore((state) => state.showErrors);

  const { setValues, values } = useDebounceState<Partial<InvestmentProfilePayload>>();

  useEffect(() => {
    if (values) {
      handleSetState(values);
    }
  }, [handleSetState, values]);
  return (
    <Box background="canvas" round="container1Round" margin={{ bottom: 'l' }} style={{ position: 'relative' }} data-testid="PurposeType-wrapper">
      <FlexControlledForm
        shouldControlValues
        fields={fields}
        testId="purpose_type_form"
        showError={showErrors}
        editMode
        onChangeValues={setValues}
        onDirty={onDirty}
      />
    </Box>
  );
};
export default PurposeType;
